import simbApi from ".";
import { ITEM_VIEW_RESYNC } from "../../data/constants/endpoints";
import logger from "../../lib/logger";

export const itemViewResync = async (access_token: string, linkedBoards: any, latestValue: any) => {
  try {
    const response = await simbApi.post(
      ITEM_VIEW_RESYNC,
      { linkedBoards: linkedBoards, latestValue: latestValue },
      {
        headers: { Authorization: `Bearer ${access_token}` },
        timeout: 0, // Disable timeout for this request
      }
    );

    if (response?.data?.error) {
      throw new Error(response?.data?.error);
    }

    return response;
  } catch (error: any) {
    logger.error(error.message);
    throw error;
  }
};
